import React from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-ink">
        <Loader2 className="animate-spin text-gold" size={40} />
      </div>
    );
  }
  if (!user || !user.is_admin) {
    return <Navigate to="/login" replace />;
  }
  return children;
}
